import { ReactNode, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ConfigurationName } from '../../enums/ConfigurationName';
import { resolvePreviewSwap } from '../../utils/featureAccess';
import { useConfigurations } from './useConfigurations';
import { UserContext } from './useUser';

interface ConfigurationPreviewRouteProps {
  children: ReactNode;
  configurationName: ConfigurationName;
  legacyPath: string;
  previewPath: string;
  version: 'legacy' | 'preview';
}

const ConfigurationPreviewRoute = ({
  children,
  configurationName,
  legacyPath,
  previewPath,
  version,
}: ConfigurationPreviewRouteProps) => {
  const { hasPermissionTo } = useContext(UserContext);
  const { isConfigurationEnabled } = useConfigurations();
  const hostname = typeof window === 'undefined' ? undefined : window.location.hostname;
  const hasAdminPermission = hasPermissionTo(['Admin']);
  const previewSwapMode = resolvePreviewSwap(hostname, false);

  if (previewSwapMode === 'both') return <>{children}</>;
  const resolvedMode = resolvePreviewSwap(hostname, isConfigurationEnabled(configurationName), hasAdminPermission);
  // 'both' (e.g. Admin showcase) means neither version should force-redirect the other.
  if (resolvedMode !== 'both' && resolvedMode !== version) {
    return (
      <Navigate
        to={resolvedMode === 'preview' ? previewPath : legacyPath}
        replace />
    );
  }

  return <>{children}</>;
};

export default ConfigurationPreviewRoute;